<template>
  <div v-if="reportData">
    <v-card elevation="2">
      <v-row justify="space-between">
        <v-col cols="6" class="py-0">
          <v-card-title primary-title>Open Quality Gaps</v-card-title>
        </v-col>
      </v-row>
      <v-card-text>
        <v-row>
          <v-col cols="5" class="pt-0">
            <v-text-field
              class="pt-0"
              v-model="search"
              label="Search"
              append-icon="mdi-search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="5" class="pt-0">
            <v-select
              v-on:change="getSelected(reportData)"
              class="pt-0"
              v-model="selectedHeaders"
              :items="headerOptions"
              :menu-props="{ maxHeight: '400' }"
              label="Fields"
              multiple
              return-object
            >
              <v-list-item slot="prepend-item" @click="toggle">
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item>
              <template v-slot:selection="{ item, index }">
                <v-chip small v-if="index < 2">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 2" class="grey--text caption"
                  >(+{{ selectedHeaders.length - 6 }} others)
                </span>
              </template>
            </v-select>
          </v-col>
          <v-col cols="2">
            <span class="mr-3"><v-chip small color="success"></v-chip> - Yes</span>
            <span><v-chip small color="error"></v-chip> - No</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :loading="load"
        :headers="selectedHeaders"
        :items="reportData"
        :search="search"
        :sort-desc="[true]"
        :footer-props="{
          'items-per-page-options': [25, 50, 75, 100, -1]
        }"
        :items-per-page="25"
        multi-sort
        loading-text="Loading data..."
        class="elevation-0 col-md-12 m-auto"
      >
        <template v-slot:body="props">
          <tr v-for="item in props.items" :key="item._id">
            <td v-for="header in selectedHeaders" :key="header.text" class="text-center">
              <div v-if="item[header.value] === 'Y'">
                <v-chip small color="success"></v-chip>
              </div>
              <div v-else-if="item[header.value] === 'N'">
                <v-chip small color="error"></v-chip>
              </div>
              <div v-else-if="header.value === 'DETAILS'">
                <patient-modal :patient="item" :insurance="insurance" />
              </div>
              <div v-else>{{ item[header.value]}}</div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import PatientModal from "../PatientModal";

export default {
  name: "qualityGaps",
  props: [
    "organization",
    "groups",
    "providers",
    "locations",
    "insurance",
    "startDate",
    "endDate",
    "reportData"
  ],
  components: {
    PatientModal
  },
  data() {
    return {
      search: "",
      load: false,
      pagination: "",
      user: "",
      headers: [],
      headerOptions: [],
      cancelSource: null,
      selectedHeaders: [],
      changeDetected: false,
      newData: []
    };
  },
  mounted() {
    this.setHeaders();
  },
  methods: {
    async getUser() {
      await axios
        .get("/api/user")
        .then(response => {
          this.user = response.data[0];
        })
        .catch(err => this.$router.push("/login"));
    },
    setHeaders() {
      if (this.insurance === "Freedom" || this.insurance === "Optimum") {
        this.headerOptions = [
          { text: "Wellness Visit", value: "WELL_VISIT" },
          { text: "ART", value: "RA_DRUG_TX" },
          { text: "OMW", value: "OSTEO_MGMT" },
          { text: "CDC2_NPH", value: "DM_NEPHRO" },
          { text: "DM Ldl Cholesterol Screening", value: "DM_LDL_C_Scrn" },
          { text: "DM Ldl Cholesterol Level", value: "DM_LDL_C_LVL" },
          { text: "CDC2_EYE", value: "DM_Eye_Exam" },
          { text: "Colorectal Cancer Screening (COL)", value: "Colon_CA_SCRN" },
          { text: "DM Ldl Cholesterol Screening", value: "CV_LDL_C_SCRN" },
          { text: "COA_MDR", value: "COA_RX_REVIEW" },
          { text: "COA_PNS", value: "COA_PAIN_ASMT" },
          { text: "COA_FSA", value: "COA_FSA" },
          { text: "COA_ACP", value: "COA_ADV_CARE_PLAN" },
          { text: "Breast Cancer Screening (BCS)", value: "BREAST_CANCER_SCRN" }
        ];
        this.selectedHeaders = [
          { text: "Member Id", value: "Member_Id" },
          { text: "Patient Name", value: "PATIENT_NAME" },
          { text: "DOB", value: "DOB" },
          { text: "Phone Number", value: "MEMBER_PHONE_NO" },
          { text: "pcp id", value: "pcp_id" },
          { text: "PCP Name", value: "PCP_Name" },
          { text: "PCP ADD SUFF", value: "PCP_Add_Suff" },
          { text: "PCP Address", value: "PCP_ADDRESS" },
          { text: "Wellness Visit", value: "WELL_VISIT" },
          { text: "ART", value: "RA_DRUG_TX" },
          { text: "OMW", value: "OSTEO_MGMT" },
          { text: "CDC2_NPH", value: "DM_NEPHRO" },
          { text: "DM Ldl Cholesterol Screening", value: "DM_LDL_C_Scrn" },
          { text: "DM Ldl Cholesterol Level", value: "DM_LDL_C_LVL" },
          { text: "CDC2_EYE", value: "DM_Eye_Exam" },
          { text: "Colorectal Cancer Screening (COL)", value: "Colon_CA_SCRN" },
          { text: "DM Ldl Cholesterol Screening", value: "CV_LDL_C_SCRN" },
          { text: "COA_MDR", value: "COA_RX_REVIEW" },
          { text: "COA_PNS", value: "COA_PAIN_ASMT" },
          { text: "COA_FSA", value: "COA_FSA" },
          { text: "COA_ACP", value: "COA_ADV_CARE_PLAN" },
          { text: "Breast Cancer Screening (BCS)", value: "BREAST_CANCER_SCRN" }
        ];
      } else if (this.insurance === "Humana") {
        this.headerOptions = [
          { text: "ADH_ACE", value: "ADH_ACE" },
          { text: "ADH_DIAB", value: "ADH_DIAB" },
          { text: "ADH_STATIN", value: "ADH_STATIN" },
          { text: "ART", value: "ART" },
          { text: "Breast Cancer Screening (BCS)", value: "BCS" },
          { text: "Controlling High Blood Pressure (CBP)", value: "CBP" },
          { text: "CDC2_EYE", value: "CDC2_EYE" },
          { text: "CDC2_HBAPOOR", value: "CDC2_HBAPOOR" },
          { text: "CDC2_NPH", value: "CDC2_NPH" },
          { text: "COA_FSA", value: "COA_FSA" },
          { text: "COA_MDR", value: "COA_MDR" },
          { text: "COA_PNS", value: "COA_PNS" },
          { text: "Colorectal Cancer Screening (COL)", value: "COL" },
          { text: "MRP", value: "MRP" },
          { text: "OMW", value: "OMW" },
          { text: "Plan All-Cause Readmissions (PCR)", value: "PCR" },
          { text: "SPC_STATIN", value: "SPC_STATIN" },
          { text: "SUPD", value: "SUPD" }
        ];

        this.selectedHeaders = [
          { text: "Patient Name", value: "PATIENT_NAME" },
          { text: "DOB", value: "DOB" },
          { text: "Patient ID", value: "ID" },
          { text: "RPT_PE", value: "RPT_PE" },
          { text: "Open Opportunities", value: "OPEN_CONDITIONS" },
          { text: "ADH_ACE", value: "ADH_ACE" },
          { text: "ADH_DIAB", value: "ADH_DIAB" },
          { text: "ADH_STATIN", value: "ADH_STATIN" },
          { text: "ART", value: "ART" },
          { text: "Breast Cancer Screening (BCS)", value: "BCS" },
          { text: "Controlling High Blood Pressure (CBP)", value: "CBP" },
          { text: "CDC2_EYE", value: "CDC2_EYE" },
          { text: "CDC2_HBAPOOR", value: "CDC2_HBAPOOR" },
          { text: "CDC2_NPH", value: "CDC2_NPH" },
          { text: "COA_FSA", value: "COA_FSA" },
          { text: "COA_MDR", value: "COA_MDR" },
          { text: "COA_PNS", value: "COA_PNS" },
          { text: "Colorectal Cancer Screening (COL)", value: "COL" },
          { text: "MRP", value: "MRP" },
          { text: "OMW", value: "OMW" },
          { text: "Plan All-Cause Readmissions (PCR)", value: "PCR" },
          { text: "SPC_STATIN", value: "SPC_STATIN" },
          { text: "SUPD", value: "SUPD" },
          { text: "Details", value: "DETAILS" }
        ];
      } else if (this.insurance === "Careplus") {
        this.headerOptions = [
          { text: "ABA", value: "ABA" },
          { text: "ART", value: "ART" },
          { text: "Breast Cancer Screening (BCS)", value: "BCS" },
          { text: "Controlling High Blood Pressure (CBP)", value: "CBP" },
          { text: "CDC2_EYE", value: "CDC2_EYE" },
          { text: "CDC2_HBAPOOR", value: "CDC2_HBAPOOR" },
          { text: "CDC2_HBATEST", value: "CDC2_HBATEST" },
          { text: "CDC2_NPH", value: "CDC2_NPH" },
          { text: "COA_ACP", value: "COA_ACP" },
          { text: "COA_FSA", value: "COA_FSA" },
          { text: "COA_MDR", value: "COA_MDR" },
          { text: "COA_PNS", value: "COA_PNS" },
          { text: "Colorectal Cancer Screening (COL)", value: "COL" },
          { text: "MRP", value: "MRP_MRP" },
          { text: "OMW", value: "OMW" },
          { text: "Plan All-Cause Readmissions (PCR)", value: "PCR2" },
          { text: "SPC_STATIN", value: "SPC_Therapy" },
          { text: "SUPD", value: "PartD_SUPD" }
        ];

        this.selectedHeaders = [
          { text: "Patient Name", value: "PATIENT_NAME" },
          { text: "DOB", value: "DOB" },
          { text: "Patient ID", value: "ID" },
          { text: "RPT_PE", value: "RPT_PE" },
          { text: "Open Opportunities", value: "OPEN_CONDITIONS" },
          { text: "ABA", value: "ABA" },
          { text: "ART", value: "ART" },
          { text: "Breast Cancer Screening (BCS)", value: "BCS" },
          { text: "Controlling High Blood Pressure (CBP)", value: "CBP" },
          { text: "CDC2_EYE", value: "CDC2_EYE" },
          { text: "CDC2_HBAPOOR", value: "CDC2_HBAPOOR" },
          { text: "CDC2_HBATEST", value: "CDC2_HBATEST" },
          { text: "CDC2_NPH", value: "CDC2_NPH" },
          { text: "COA_ACP", value: "COA_ACP" },
          { text: "COA_FSA", value: "COA_FSA" },
          { text: "COA_MDR", value: "COA_MDR" },
          { text: "COA_PNS", value: "COA_PNS" },
          { text: "Colorectal Cancer Screening (COL)", value: "COL" },
          { text: "MRP", value: "MRP_MRP" },
          { text: "OMW", value: "OMW" },
          { text: "Plan All-Cause Readmissions (PCR)", value: "PCR2" },
          { text: "SPC_STATIN", value: "SPC_Therapy" },
          { text: "SUPD", value: "PartD_SUPD" },
          { text: "Details", value: "DETAILS" }
        ];
      }
    },
    getSelected() {
      this.load = true;
      const newArr = [];

      if (this.reportData.length > 0) {
        if (this.insurance === "Freedom" || this.insurance === "Optimum") {
          this.reportData.forEach(item => {
            item.newField = [];
            this.selectedHeaders.forEach(header => {
              if (item[header.value] == "Req'd") {
                item.newField.push("Req'd");
              } else {
                item.newField.push("Req'd");
              }
            });
            item.newField = item.newField.slice(8);
            if (item.newField.includes("Req'd")) {
              newArr.push(item);
            }
          });
        } else if (this.insurance === "Humana" || this.insurance === "Careplus") {
          this.reportData.forEach(item => {
            item.newField = [];
            this.selectedHeaders.forEach(header => {
              if (item[header.value] == "Y") {
                item.newField.push("Y");
              } else {
                item.newField.push("N");
              }
            });
            item.newField = item.newField.slice(4);
            if (item.newField.includes("Y")) {
              newArr.push(item);
            }
          });
        }

        this.newData = newArr;
      }

      this.load = false;
    },
    toggle() {
      if (this.insurance === "Humana" || this.insurance === "Careplus") {
        if (this.selectedHeaders.length <= 6) {
          this.$nextTick(() => {
            const newHeaders = [
              { text: "Patient Name", value: "PATIENT_NAME" },
              { text: "DOB", value: "DOB" },
              { text: "Patient ID", value: "ID" },
              { text: "RPT_PE", value: "RPT_PE" },
              { text: "Open Opportunities", value: "OPEN_CONDITIONS" },
              ...this.headerOptions,
              { text: "Details", value: "DETAILS" }
            ];
            this.selectedHeaders = newHeaders;
            this.getSelected();
          });
        } else if (this.selectedHeaders.length > 6) {
          this.selectedHeaders = [
            { text: "Patient Name", value: "PATIENT_NAME" },
            { text: "DOB", value: "DOB" },
            { text: "Patient ID", value: "ID" },
            { text: "RPT_PE", value: "RPT_PE" },
            { text: "Open Opportunities", value: "OPEN_CONDITIONS" },
            { text: "Details", value: "DETAILS" }
          ];
        }
      } else if (this.insurance === "Freedom" || this.insurance === "Optimum") {
        if (this.selectedHeaders.length <= 8) {
          this.$nextTick(() => {
            const newHeaders = [
              { text: "Member Id", value: "Member_Id" },
              { text: "Patient Name", value: "PATIENT_NAME" },
              { text: "DOB", value: "DOB" },
              { text: "Phone Number", value: "MEMBER_PHONE_NO" },
              { text: "pcp id", value: "pcp_id" },
              { text: "PCP Name", value: "PCP_Name" },
              { text: "PCP ADD SUFF", value: "PCP_Add_Suff" },
              { text: "PCP Address", value: "PCP_ADDRESS" },
              ...this.headerOptions
            ];
            this.selectedHeaders = newHeaders;
            this.getSelected();
          });
        } else if (this.selectedHeaders.length > 8) {
          this.selectedHeaders = [
            { text: "Member Id", value: "Member_Id" },
            { text: "Patient Name", value: "PATIENT_NAME" },
            { text: "DOB", value: "DOB" },
            { text: "Phone Number", value: "MEMBER_PHONE_NO" },
            { text: "pcp id", value: "pcp_id" },
            { text: "PCP Name", value: "PCP_Name" },
            { text: "PCP ADD SUFF", value: "PCP_Add_Suff" },
            { text: "PCP Address", value: "PCP_ADDRESS" }
          ];
        }
      }
    }
  }
};
</script>
